import { Box } from '@mui/system'
import { Typography } from '@mui/material'
import ChevronRightIcon from '@mui/icons-material/ChevronRight'
import { useState } from 'react'
import { ReactComponent as TeamSnap } from '../../images/TeamSnap.svg'
import { ReactComponent as ImportantNote } from '../../images/ImportantNote.svg'
import UseTranslation from '../../hooks/UseTranslation'
import TitleWithIcon from '../../components/Cards/helpers/TitleWithIcon'
import CardWithSpace from '../../components/Cards/CardWithSpace'
import SvgIconSize from '../../components/Cards/helpers/SvgIconSize'
import RoleModuleModal from './RoleModuleModal'

const ImportUsersRolesTips = () => {
  const { t } = UseTranslation()
  const [roleModuleModal, setRoleModuleModal] = useState(false)

  return (
    <Box sx={styles.tipsContainer}>
      <Box sx={styles.tipsTitleContainer}>
      <TitleWithIcon
          title={t?.['Import User\'s Roles Tips']}
          icon={<ImportantNote />}
          iconSize="lg"
          textVariant="heading3"
          customStyle={styles.tipsTitle}
        />
        <Box sx={styles.tipsTitleTextContainer} onClick={() => setRoleModuleModal(true)}>
          <ChevronRightIcon />
          <Typography sx={styles.libraryText} variant='heading6'>{t?.['Roles and Modules Library']}</Typography>
      </Box>
      </Box>
      <Box sx={styles.tipsSubTile}>
        <Typography variant='heading7' sx={styles.tipsSubTitleText}>
          {t?.['Please follow the instructions below when preparing your file for import:']}
        </Typography>
        <TitleWithIcon
          title={t?.Mandatory}
          icon={<TeamSnap />}
          iconSize="md"
          textVariant="heading6"
          customStyle={styles.mandatoryIcon}
        />
      </Box>
      <Box sx={{ ...styles.tipsTableWrapper }}>
      <Box sx={styles.tipsTable}>
        <Box sx={{ minWidth: '800px' }}>
        <CardWithSpace sx={styles.tipsTableRowHeader}>
          <Typography variant='heading5' sx={styles.tipsTableRowHeaderText}>{t?.['Column Number']}</Typography>
          <Typography variant='heading5' sx={styles.tipsTableRowHeaderText}>{t?.['Field Title']}</Typography>
          <Typography variant='heading5' sx={styles.tipsTableRowHeaderText}>{t?.Description}</Typography>
          <Typography variant='heading5' sx={styles.tipsTableRowHeaderText}>{t?.Notes}</Typography>
        </CardWithSpace>
        <CardWithSpace sx={styles.tipsTableRowData}>
          <Typography variant='heading5' sx={styles.tipsTableRowDataText}>1</Typography>
          <Typography variant='heading5' sx={styles.tipsTableRowDataText}>{t?.['E-Mail Address']}</Typography>
          <Typography variant='heading5' sx={styles.tipsTableRowDataText}>
            {t?.['Enter the email of the user you want to assign roles to.']}
          </Typography>
          <Typography variant='heading5' sx={styles.tipsTableRowDataText}>
            {t?.['Leave it empty if already added data in C2']}
          </Typography>
        </CardWithSpace>
        <CardWithSpace sx={styles.tipsTableRowData}>
          <Typography variant='heading5' sx={styles.tipsTableRowDataText}>2</Typography>
          <Typography variant='heading5' sx={styles.tipsTableRowDataText}>{t?.['Employee Code']}</Typography>
          <Typography variant='heading5' sx={styles.tipsTableRowDataText}>
            {t?.['Enter the code of the employee you need to assign roles to.']}
          </Typography>
          <Typography variant='heading5' sx={styles.tipsTableRowDataText}>
            {t?.['Leave it empty if already added data in C1']}
          </Typography>
        </CardWithSpace>
        <Box sx={styles.tipsNote}>
          <Typography sx={styles.tipsNoteText}>
            <Box component="span">{t?.['Note : ']}</Box>
            {t?.['You must enter at least one of the previous fields ( C1 or C2 ) in each row.']}
          </Typography>
          <SvgIconSize icon={<TeamSnap />} size="xs" />
        </Box>
        <CardWithSpace sx={styles.tipsTableRowData}>
          <Typography variant='heading5' sx={styles.tipsTableRowDataText}> <SvgIconSize icon={<TeamSnap />} size="xs" customStyle={styles.tipsTableRowDataTextIcon} />3</Typography>
          <Typography variant='heading5' sx={styles.tipsTableRowDataText}>{t?.Module}</Typography>
          <Typography variant='heading5' sx={styles.tipsTableRowDataText}>
            {t?.['Specify the module to which the role belongs (e.g., Self Service, EDS ).']}
          </Typography>
          <Typography variant='heading5' sx={styles.tipsTableRowDataText}>
            {t?.['Check the exact spelling as defined in our system']}
          </Typography>
        </CardWithSpace>
        <CardWithSpace sx={styles.tipsTableRowData}>
          <Typography variant='heading5' sx={styles.tipsTableRowDataText}> <SvgIconSize icon={<TeamSnap />} size="xs" customStyle={styles.tipsTableRowDataTextIcon} />4</Typography>
          <Typography variant='heading5' sx={styles.tipsTableRowDataText}>{t?.Role}</Typography>
          <Typography variant='heading5' sx={styles.tipsTableRowDataText}>
            {t?.['Specify the name of the role to assign (e.g., manager, hr, etc.).']}
          </Typography>
          <Typography variant='heading5' sx={styles.tipsTableRowDataText}>
            {t?.['Check the exact spelling as defined in our system']}
          </Typography>
        </CardWithSpace>
          </Box>
          </Box>
    </Box>
      <RoleModuleModal
        formModalState={roleModuleModal}
        setFormModalState={setRoleModuleModal}
      />
    </Box>
  )
}

const styles = {
  tipsContainer: {
    marginBlock: '20px',
  },
  tipsTitleContainer: {
    position: 'relative',
    display: 'flex',
    flexDirection: { xs: 'column', md: 'row' },
    justifyContent: 'space-between',
    alignItems: 'flex-start',
    gap: { xs: '15px', md: '0px' },
    marginBottom: { xs: '25px !important', md: '15px !important' },
  },
  tipsTitle: {
    gap: '5px',
  },
  tipsTitleTextContainer: {
    display: 'flex',
    alignItems: 'center',
    gap: '5px',
    cursor: 'pointer',
    color: 'primary.main',
    position: { xs: 'absolute', md: 'static' },
    right: '0',
    top: '25px',
    '& span': {
      textDecoration: 'underline',
    },
  },
  tipsSubTile: {
    width: '100%',
    display: 'flex',
    justifyContent: 'space-between',
    gap: '10px',
    marginBottom: '15px',
  },
  mandatoryIcon: {
    gap: '5px',
    '& svg': {
      width: { xs: '17px !important', md: '22px !important' },
      height: { xs: '17px !important', md: '22px !important' },
    },
  },
  tipsSubTitleText: {
    color: 'text.disabled',
    paddingLeft: { xs: '0px', md: '40px' },
  },
  tipsTableRowHeader: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    gap: { xs: '0px !important', sm: '10px' },
    backgroundColor: 'primary.main',
    borderRadius: '8px',
    height: '40px',
    position: 'sticky',
    top: 0,
    zIndex: 1,
  },
  tipsTableWrapper: {
    position: 'relative',
  },
  tipsTableRowHeaderText: {
    color: 'text.main',
    flex: 1,
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    textAlign: 'center',
    minWidth: { xs: '200px', md: 'unset' },
    '&:nth-of-type(1)': { flex: '1.5' },
    '&:nth-of-type(2)': { flex: '2' },
    '&:nth-of-type(3)': { flex: '3' },
    '&:nth-of-type(4)': { flex: '3' },
  },
  tipsTableRowData: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    gap: { xs: '0px !important', sm: '10px' },
    boxShadow: '0px 0px 1px 0px rgba(0, 0, 0, 0.1)',
    marginTop: '15px',
    borderRadius: '8px',
    height: '55px',
    backgroundColor: 'background.paper',
  },
  tipsTableRowDataText: {
    flex: 1,
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    textAlign: 'center',
    minWidth: { xs: '200px', md: 'unset' },
    '&:nth-of-type(1)': { flex: '1.5' },
    '&:nth-of-type(2)': { flex: '2' },
    '&:nth-of-type(3)': { flex: '3' },
    '&:nth-of-type(4)': { flex: '3' },
  },
  tipsNote: {
    margin: '15px 0',
    display: 'flex',
    alignItems: 'center',
    gap: '8px',
  },
  tipsNoteText: {
    color: 'text.disabled',
    '& span': {
      color: 'text.primary',
    },
  },
  tipsTableRowDataTextIcon: {
    marginLeft: '-50px',
    marginRight: '35px',
  },
  tipsTable: {
    width: '100%',
    overflowX: 'auto',
  },
}
export default ImportUsersRolesTips;
